import { jwtDecode } from "jwt-decode"
import type { JwtPayload } from "jwt-decode"

export const isValidToken = (accessToken: string | null) => {
  if (!accessToken) {
    return false
  }

  const decoded: JwtPayload = jwtDecode(accessToken)
  const currentTime = Date.now()

  const expiredate = decoded.exp ? (decoded.exp - 300) * 1000 : 0

  const valid = expiredate > currentTime

  return valid
}
